export default "__VITE_ASSET__DOm0V4jO__"